import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import HomeV4 from "./pages/HomeV4";
import {Thankyou} from "./components/ThankYou";


// V1 multi-page chrome is shown for V1 routes only; other versions are self-contained
const V1_ROUTES = ["/v1", "/about", "/services", "/products", "/industries", "/contact"];

function ChromeShell() {
  const location = useLocation();
  const path = location.pathname;
  const showV1Chrome = V1_ROUTES.some((p) => path === p || path.startsWith(`${p}/`));

  return (
    <>
      {showV1Chrome && <Header />}
      <Routes>
        <Route path="/" element={<HomeV4 />} />
        <Route path="/thank-you" element={<Thankyou />} />
      </Routes>
      {showV1Chrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App bg-white min-h-screen text-navy-900">
      <BrowserRouter>
        <ChromeShell />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
